import {ConnectionHandler,} from 'relay-runtime'








const getGitLabProjectsIssuesConn = (
  gitlabTeamMemberIntegration,
  projectsIssuesArgs
) => {
  if (!gitlabTeamMemberIntegration) return null
  return ConnectionHandler.getConnection(
    gitlabTeamMemberIntegration,
    'GitLabScopingSearchResults_projectsIssues',
    projectsIssuesArgs
  )
}

export default getGitLabProjectsIssuesConn
